import { Grid } from '@mui/material';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import WorkQueues from 'enums/workQueue.enum';
import { listOrdersForProductFulfillmentByPage } from 'store/thunks/workQueueThunks';
import { useWorkQueueTabSwitch } from '../contexts/WorkQueueTabSwitchContext';

import ProductFulfillmentStatusBar from './ProductFulfillmentFilterStatusBar';
import ProductFulfillmentFilterButton from './ProductFulfillmentFilterButton';
import ProductFulfillmentTable from './ProductFulfillmentTable';

const ProductFulfillment = () => {
  const dispatch = useDispatch();
  const preset = useSelector(({ workQueue }) => workQueue.preset);
  const { currentPage } = useSelector(
    ({ workQueue }) => workQueue.productFulfillment,
    shallowEqual
  );
  const { isTabSwitch } = useWorkQueueTabSwitch();

  useEffect(() => {
    if (isTabSwitch(WorkQueues.PRODUCT_FULFILLMENT)) {
      dispatch(listOrdersForProductFulfillmentByPage({ page: currentPage }));
    }
  }, [dispatch, currentPage, isTabSwitch]);

  if (preset !== WorkQueues.PRODUCT_FULFILLMENT) return null;
  return (
    <Grid container sx={{ py: 2 }}>
      <Grid item sx={{ minHeight: 40, flexGrow: 1 }} alignItems='center'>
        <ProductFulfillmentStatusBar />
      </Grid>
      <Grid item>
        <ProductFulfillmentFilterButton />
      </Grid>
      <ProductFulfillmentTable />
    </Grid>
  );
};

export default ProductFulfillment;
